import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { startConnectionListingLifecycle } from '../services/connectionListingLifecycle';

/**
 * Renders nothing; keeps the connection-lifecycle eviction of the Object
 * Explorer's query cache alive for the whole app session.
 *
 * It has to live OUTSIDE the Explorer: `DatabaseExplorer` — which owns
 * `endConnectionGeneration` — is unmounted whenever the sidebar's explorer pane
 * is collapsed, and a disconnect / reconnect / delete that happens then would
 * otherwise leave the dead connect's cached rows (above all its database
 * listing, which every picker paints from) in the cache. See
 * `connectionListingLifecycle.ts`.
 */
export function DatabaseListingLifecycleHost(): null {
  const queryClient = useQueryClient();
  useEffect(() => startConnectionListingLifecycle(queryClient), [queryClient]);
  return null;
}
